import React, { FC } from 'react';

const SpotifyIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="20"
    height="20"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-23.000000, -89.000000)"
        fill="#000000"
        fillRule="nonzero"
      >
        <g transform="translate(23.000000, 89.000000)">
          <path
            d="M15.915,8.865 C12.692,6.951 7.375,6.775 4.298,7.709 C3.80370515,7.85894531 3.28144531,7.57979485 3.1315,7.0855 C2.98155469,6.59120515 3.26070515,6.06894531 3.755,5.919 C7.287,4.847 13.159,5.054 16.87,7.256 C17.1575988,7.42659432 17.3323401,7.7376621 17.3284657,8.07202713 C17.3244608,8.40639216 17.1424389,8.71325642 16.8509005,8.87702713 C16.559362,9.04079784 16.2025988,9.03659432 15.915,8.866 L15.915,8.865 Z M15.81,11.701 C15.7016629,11.8772407 15.5277495,12.0032243 15.3265213,12.051234 C15.1252932,12.0992437 14.9132349,12.0653465 14.737,11.957 C12.05,10.305 7.952,9.827 4.773,10.792 C4.36619144,10.9018971 3.94564633,10.6688168 3.82322225,10.2656011 C3.70079817,9.86238536 3.92076274,9.43483394 4.32,9.3 C7.952,8.198 12.467,8.732 15.553,10.629 C15.9197504,10.8542322 16.0347598,11.3339598 15.81,11.701 L15.81,11.701 Z M14.586,14.424 C14.4998815,14.5651819 14.3611634,14.6663307 14.2004117,14.7051587 C14.03966,14.7439867 13.8700664,14.7173076 13.729,14.631 C11.381,13.196 8.425,12.871 4.944,13.667 C4.60848701,13.7434914 4.27449144,13.533513 4.198,13.198 C4.12150856,12.862487 4.33148701,12.5284914 4.667,12.452 C8.477,11.581 11.744,11.956 14.379,13.566 C14.673,13.746 14.766,14.13 14.586,14.424 L14.586,14.424 Z M10,0 C4.477,0 0,4.477 0,10 C0,15.523 4.477,20 10,20 C15.523,20 20,15.523 20,10 C20,4.477 15.523,0 10,0 Z"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SpotifyIcon;
